/** Ce que la liste, le dossier et le tiroir de la file lisent de la même façon dans une inscription. */
export default {
  computed: {
    /** Accepter ou refuser une inscription : le gestionnaire qui approuve (ou ZEborne). */
    mayApproveMembers() {
      return (this.currentUser?.permissions || []).includes('MEMBER_APPROVE')
    },
  },

  methods: {
    /** Le nom de la personne quand on le connaît, son adresse e-mail sinon : une ligne sans libellé ne sert à rien. */
    registrationName(registration) {
      const a = registration?.applicant || {}
      return [a.firstname, a.lastname].filter(Boolean).join(' ') || registration?.email || '-'
    },

    registrationAddress(registration) {
      const a = registration?.applicant?.postalAddress || {}
      return [[a.number, a.street].filter(Boolean).join(' '), a.additionalInformation, [a.zipcode, a.city].filter(Boolean).join(' ')]
        .filter(Boolean).join(', ') || '-'
    },

    /** La carte ou le compte donné, comme la personne le reconnaîtrait : jamais plus que la fin du numéro. */
    paymentMethodLabel(p) {
      if (!p) return null
      if (p.instrument === 'card') {
        const brand = p.brand ? p.brand.charAt(0).toUpperCase() + p.brand.slice(1) : this.$t('onboarding.registration.card')
        const expiry = p.expMonth && p.expYear ? ` · ${String(p.expMonth).padStart(2, '0')}/${String(p.expYear).slice(-2)}` : ''
        return `${brand} •••• ${p.last4 || '????'}${expiry}`
      }
      return `${this.$t('onboarding.registration.sepa')} •••• ${p.ibanLast4 || '????'}`
    },

    registrationStatusColor(status) {
      if (status === 'active') return 'green'
      if (status === 'cancelled' || status === 'expired') return 'grey'
      if (status === 'rejected') return 'red'
      if (status === 'validated' || status === 'created') return 'blue'
      if (status && status.startsWith('awaiting')) return 'orange'
      return 'blue-grey'
    },
  },
}
